import { useDroppable } from "@dnd-kit/core"
import { green } from "@ant-design/colors"
import { GroupLineConnector } from "./WorkareaComponent"
import { Button, Typography } from "antd"

type Props = {
  groupId: string
  onAddNewWorkarea?: () => void
}

const EmptyGroupIndicator = ({ groupId, onAddNewWorkarea }: Props) => {
  const { setNodeRef, isOver } = useDroppable({ id: `empty-group-${groupId}`, data: { type: 'empty-group', groupId } })
  const style: React.CSSProperties = {
    borderWidth: '2px',
    borderStyle: 'dashed',
    borderColor: isOver ? green.primary : '#e9e9e9',
    borderRadius: '5px',
    padding: '32px',
    marginBottom: '5px',
    marginLeft: '54px',
    textAlign: 'center',
  }

  return <div style={{position: 'relative'}}>
      <GroupLineConnector />
      <div style={{height: '16px'}}></div>
      <div 
    style={style} 
    ref={setNodeRef}
  >
    Drag a work area to the group 
    <Button 
      type="text"
      size="small" 
      onClick={onAddNewWorkarea}
    >
      <Typography.Text underline>
        or click here to add a workarea
      </Typography.Text>
    </Button>
  </div>
    </div>
}

export default EmptyGroupIndicator
